/* eslint-disable import/no-named-as-default-member */
/* eslint-disable import/no-named-as-default */
import React from 'react';
import { createRoot } from 'react-dom/client';

import App from 'App/app.jsx';
import initStore from 'App/initStore';
// eslint-disable-next-line
import registerServiceWorker from 'Utils/PWA';

import AppNotificationMessages from './App/Containers/app-notification-messages.jsx';

// Iframe mode detection — runs before React mounts, same pattern as ndunyadtrader
const is_embedded = window !== window.top;

if (is_embedded) {
    document.documentElement.classList.add('iframe-mode');
    if (document.body) document.body.classList.add('iframe-mode');
    // eslint-disable-next-line no-console
    console.log('DTrader iframe mode enabled — added iframe-mode class to body (index.tsx)');

    // When embedded, the parent app and iframe share an origin and therefore share
    // service worker scope. A SW registered by dtrader on `new.money8gg.com` would
    // intercept the PARENT app's requests too, and cache old dtrader bundles via
    // CacheFirst — making redeploys invisible until the SW is manually evicted.
    // Defensive: actively unregister any prior SW on this origin and skip register.
    if ('serviceWorker' in navigator) {
        navigator.serviceWorker
            .getRegistrations()
            .then(regs => regs.forEach(reg => reg.unregister()))
            .catch(() => {});
        if (window.caches?.keys) {
            window.caches.keys().then(keys => keys.forEach(k => window.caches.delete(k))).catch(() => {});
        }
    }
} else if (
    !!window?.localStorage.getItem?.('debug_service_worker') || // To enable local service worker related development
    !window.location.hostname.startsWith('localhost')
) {
    registerServiceWorker();
}

const initApp = async () => {
    // For simplified authentication, we don't need to pass accounts to initStore
    // The authentication will be handled by temp-auth.js and client-store.js
    // initStore is now async to perform whoami check before WebSocket connection
    const root_store = await initStore(AppNotificationMessages);

    const wrapper = document.getElementById('derivatives_trader');
    if (wrapper) {
        const root = createRoot(wrapper);
        root.render(<App root_store={root_store} />);
    }
};

initApp();
